export const eventTypeColors = {
    "bollywood dj night": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "bollywood nights": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "dj night": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "comedy night": "linear-gradient(95.58deg, #338EF9 12.18%, #36D9E3 86.93%)",
    "live music": "linear-gradient(95.58deg, #73BF9B 12.18%, #4B6CB7 86.93%)",
    "ladies dj night": "linear-gradient(95.58deg, #73BF9B 12.18%, #4B6CB7 86.93%)",
    "quiz night": "linear-gradient(95.58deg, #134E5E 12.18%, #71B280 86.93%)",
    "special occasion": "linear-gradient(95.58deg, #F97A33 12.18%, #E3BD36 86.93%)",
    "open mic night": "linear-gradient(95.58deg, #8CA6DB 12.18%, #B993D6 86.93%)",
    "karaoke night": "linear-gradient(95.58deg, #649173 12.18%, #DBD5A4 86.93%)",
    "sports screening": "linear-gradient(95.58deg, #1D2B64 12.18%, #F8CDDA 86.93%)",
    "holi party": "linear-gradient(90.95deg, #F9A503 3.11%, #73B3FF 34.63%, #FF8787 64.66%, rgba(255, 20, 109, 0.75) 99.18%)",
};
export const tablePerksIcons = {
    "Private Waiter": "/icons/private-waiter.svg",
    "Valet Parking": "/icons/valet-parking.svg",
    "Party Guns": "/icons/party-guns.svg",
    "Bottle Service": "/icons/bottle-service.svg",
    "Customized Lighting": "/icons/customized-lighting.svg",
    "Exclusive Lounge Access": "/icons/exclusive-lounge.svg",
    "Personal DJ Shoutouts": "/icons/dj-shoutouts.svg",
    "Complimentary Champagne": "/icons/complimentary-champagne.svg",
    "Special Table Décor": "/icons/special-decor.svg",
    "Photo Booth Access": "/icons/photo-booth.svg",
    "Priority Entry": "/icons/priority-entry.svg",
    "VIP Wristbands": "/icons/vip-wristbands.svg",
    "Appetizer Platter": "/icons/appetizer-platter.svg",
    "Personalized Cake": "/icons/personalized-cake.svg",
    "Private Security": "/icons/private-security.svg",
    "Hookah Service": "/icons/hookah-service.svg",
    "Reserved Parking Spot": "/icons/reserved-parking.svg",
    "Table-side Mixologist": "/icons/mixologist.svg",
    "Customized Drink Menu": "/icons/custom-drink-menu.svg",
    "Private Dance Floor Access": "/icons/dance-floor.svg",
};
export const menuTypeTheme = {
    bbq: {
        primary: "#E86500",
        theme: "dark",
    },
    floral: {
        primary: "#4B678A",
        secondary: "#F3F6EE",
        theme: "light",
    },
    beach: {
        primary: "#00E8C9",
        theme: "dark",
    },
    rooftop: {
        primary: "#967d45",
        theme: "dark",
    },
    nonvegthali: {
        primary: "#7A0000",
        secondary: "#F2E4C9",
        theme: "light",
    },
    vegthali: {
        primary: "#7A0000",
        secondary: "#F2E4C9",
        theme: "light",
    },
    blossom: {
        primary: "#C05D71",
        theme: "light",
    },
    classic_light: {
        primary: "#0C5D56",
        theme: "light",
    },
    classic_dark: {
        primary: "#A6763B",
        theme: "dark",
    },
    finedine_normal: {
        primary: "#E86500",
        theme: "dark",
    },
    finedine_premium: {
        primary: "#E86500",
        theme: "dark",
    },
    cafe_normal: {
        primary: "#B9774C",
        secondary: "#F1E7D7",
        theme: "light",
    },
    cafe_premium: {
        primary: "#B9774C",
        theme: "dark",
    },
};
export const categoryLabel = {
    chefRecommend: "Chef's Recommended",
    specialItems: "Today's Special",
};
export const ThemisFoodCourtPubs = {
    600: {
        name: "Themis Greek House Murthal",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/600.png",
    },
    623: {
        name: "Themis Greek House BYOB",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/623.jpeg",
    },
    663: {
        name: "Athens Pizza",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/663.jpeg",
    },
    664: {
        name: "Dosa Plaza",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/664.jpeg",
    },
    665: {
        name: "Barista",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/665.jpeg",
    },
    666: {
        name: "Themis Street Food",
        image: "https://d1hddaam55e99y.cloudfront.net/pub_logos/666.png",
    },
};
export const VenueCountryCode = {
    "708": "1",
};
export const countryOptions = [
    { value: "91", label: "+91 (India)", countryCode: "IN" },
    { value: "93", label: "+93 (Afghanistan)", countryCode: "AF" },
    { value: "355", label: "+355 (Albania)", countryCode: "AL" },
    { value: "213", label: "+213 (Algeria)", countryCode: "DZ" },
    { value: "376", label: "+376 (Andorra)", countryCode: "AD" },
    { value: "244", label: "+244 (Angola)", countryCode: "AO" },
    { value: "1-268", label: "+1-268 (Antigua and Barbuda)", countryCode: "AG" },
    { value: "54", label: "+54 (Argentina)", countryCode: "AR" },
    { value: "374", label: "+374 (Armenia)", countryCode: "AM" },
    { value: "297", label: "+297 (Aruba)", countryCode: "AW" },
    { value: "61", label: "+61 (Australia)", countryCode: "AU" },
    { value: "43", label: "+43 (Austria)", countryCode: "AT" },
    { value: "994", label: "+994 (Azerbaijan)", countryCode: "AZ" },
    { value: "1-242", label: "+1-242 (Bahamas)", countryCode: "BS" },
    { value: "973", label: "+973 (Bahrain)", countryCode: "BH" },
    { value: "880", label: "+880 (Bangladesh)", countryCode: "BD" },
    { value: "1-246", label: "+1-246 (Barbados)", countryCode: "BB" },
    { value: "375", label: "+375 (Belarus)", countryCode: "BY" },
    { value: "32", label: "+32 (Belgium)", countryCode: "BE" },
    { value: "501", label: "+501 (Belize)", countryCode: "BZ" },
    { value: "229", label: "+229 (Benin)", countryCode: "BJ" },
    { value: "975", label: "+975 (Bhutan)", countryCode: "BT" },
    { value: "591", label: "+591 (Bolivia)", countryCode: "BO" },
    { value: "387", label: "+387 (Bosnia and Herzegovina)", countryCode: "BA" },
    { value: "267", label: "+267 (Botswana)", countryCode: "BW" },
    { value: "55", label: "+55 (Brazil)", countryCode: "BR" },
    { value: "673", label: "+673 (Brunei)", countryCode: "BN" },
    { value: "359", label: "+359 (Bulgaria)", countryCode: "BG" },
    { value: "226", label: "+226 (Burkina Faso)", countryCode: "BF" },
    { value: "257", label: "+257 (Burundi)", countryCode: "BI" },
    { value: "855", label: "+855 (Cambodia)", countryCode: "KH" },
    { value: "237", label: "+237 (Cameroon)", countryCode: "CM" },
    { value: "1", label: "+1 (Canada)", countryCode: "CA" },
    { value: "238", label: "+238 (Cape Verde)", countryCode: "CV" },
    { value: "236", label: "+236 (Central African Republic)", countryCode: "CF" },
    { value: "235", label: "+235 (Chad)", countryCode: "TD" },
    { value: "56", label: "+56 (Chile)", countryCode: "CL" },
    { value: "86", label: "+86 (China)", countryCode: "CN" },
    { value: "57", label: "+57 (Colombia)", countryCode: "CO" },
    { value: "269", label: "+269 (Comoros)", countryCode: "KM" },
    { value: "682", label: "+682 (Cook Islands)", countryCode: "CK" },
    { value: "506", label: "+506 (Costa Rica)", countryCode: "CR" },
    { value: "385", label: "+385 (Croatia)", countryCode: "HR" },
    { value: "53", label: "+53 (Cuba)", countryCode: "CU" },
    { value: "357", label: "+357 (Cyprus)", countryCode: "CY" },
    { value: "420", label: "+420 (Czech Republic)", countryCode: "CZ" },
    { value: "45", label: "+45 (Denmark)", countryCode: "DK" },
    { value: "253", label: "+253 (Djibouti)", countryCode: "DJ" },
    { value: "1-767", label: "+1-767 (Dominica)", countryCode: "DM" },
    { value: "1-809", label: "+1-809 (Dominican Republic)", countryCode: "DO" },
    { value: "593", label: "+593 (Ecuador)", countryCode: "EC" },
    { value: "20", label: "+20 (Egypt)", countryCode: "EG" },
    { value: "503", label: "+503 (El Salvador)", countryCode: "SV" },
    { value: "240", label: "+240 (Equatorial Guinea)", countryCode: "GQ" },
    { value: "291", label: "+291 (Eritrea)", countryCode: "ER" },
    { value: "372", label: "+372 (Estonia)", countryCode: "EE" },
    { value: "268", label: "+268 (Eswatini)", countryCode: "SZ" },
    { value: "251", label: "+251 (Ethiopia)", countryCode: "ET" },
    { value: "679", label: "+679 (Fiji)", countryCode: "FJ" },
    { value: "358", label: "+358 (Finland)", countryCode: "FI" },
    { value: "33", label: "+33 (France)", countryCode: "FR" },
    { value: "241", label: "+241 (Gabon)", countryCode: "GA" },
    { value: "220", label: "+220 (Gambia)", countryCode: "GM" },
    { value: "995", label: "+995 (Georgia)", countryCode: "GE" },
    { value: "49", label: "+49 (Germany)", countryCode: "DE" },
    { value: "233", label: "+233 (Ghana)", countryCode: "GH" },
    { value: "30", label: "+30 (Greece)", countryCode: "GR" },
    { value: "299", label: "+299 (Greenland)", countryCode: "GL" },
    { value: "1-473", label: "+1-473 (Grenada)", countryCode: "GD" },
    { value: "502", label: "+502 (Guatemala)", countryCode: "GT" },
    { value: "224", label: "+224 (Guinea)", countryCode: "GN" },
    { value: "245", label: "+245 (Guinea-Bissau)", countryCode: "GW" },
    { value: "592", label: "+592 (Guyana)", countryCode: "GY" },
    { value: "509", label: "+509 (Haiti)", countryCode: "HT" },
    { value: "504", label: "+504 (Honduras)", countryCode: "HN" },
    { value: "852", label: "+852 (Hong Kong)", countryCode: "HK" },
    { value: "36", label: "+36 (Hungary)", countryCode: "HU" },
    { value: "354", label: "+354 (Iceland)", countryCode: "IS" },
    { value: "62", label: "+62 (Indonesia)", countryCode: "ID" },
    { value: "98", label: "+98 (Iran)", countryCode: "IR" },
    { value: "964", label: "+964 (Iraq)", countryCode: "IQ" },
    { value: "353", label: "+353 (Ireland)", countryCode: "IE" },
    { value: "972", label: "+972 (Israel)", countryCode: "IL" },
    { value: "39", label: "+39 (Italy)", countryCode: "IT" },
    { value: "1-876", label: "+1-876 (Jamaica)", countryCode: "JM" },
    { value: "81", label: "+81 (Japan)", countryCode: "JP" },
    { value: "962", label: "+962 (Jordan)", countryCode: "JO" },
    { value: "7", label: "+7 (Russia)", countryCode: "RU" },
    { value: "254", label: "+254 (Kenya)", countryCode: "KE" },
    { value: "686", label: "+686 (Kiribati)", countryCode: "KI" },
    { value: "850", label: "+850 (North Korea)", countryCode: "KP" },
    { value: "82", label: "+82 (South Korea)", countryCode: "KR" },
    { value: "965", label: "+965 (Kuwait)", countryCode: "KW" },
    { value: "996", label: "+996 (Kyrgyzstan)", countryCode: "KG" },
    { value: "856", label: "+856 (Laos)", countryCode: "LA" },
    { value: "371", label: "+371 (Latvia)", countryCode: "LV" },
    { value: "961", label: "+961 (Lebanon)", countryCode: "LB" },
    { value: "266", label: "+266 (Lesotho)", countryCode: "LS" },
    { value: "231", label: "+231 (Liberia)", countryCode: "LR" },
    { value: "218", label: "+218 (Libya)", countryCode: "LY" },
    { value: "423", label: "+423 (Liechtenstein)", countryCode: "LI" },
    { value: "370", label: "+370 (Lithuania)", countryCode: "LT" },
    { value: "352", label: "+352 (Luxembourg)", countryCode: "LU" },
    { value: "853", label: "+853 (Macao)", countryCode: "MO" },
    { value: "389", label: "+389 (North Macedonia)", countryCode: "MK" },
    { value: "261", label: "+261 (Madagascar)", countryCode: "MG" },
    { value: "265", label: "+265 (Malawi)", countryCode: "MW" },
    { value: "60", label: "+60 (Malaysia)", countryCode: "MY" },
    { value: "960", label: "+960 (Maldives)", countryCode: "MV" },
    { value: "223", label: "+223 (Mali)", countryCode: "ML" },
    { value: "356", label: "+356 (Malta)", countryCode: "MT" },
    { value: "692", label: "+692 (Marshall Islands)", countryCode: "MH" },
    { value: "222", label: "+222 (Mauritania)", countryCode: "MR" },
    { value: "230", label: "+230 (Mauritius)", countryCode: "MU" },
    { value: "52", label: "+52 (Mexico)", countryCode: "MX" },
    { value: "691", label: "+691 (Micronesia)", countryCode: "FM" },
    { value: "373", label: "+373 (Moldova)", countryCode: "MD" },
    { value: "377", label: "+377 (Monaco)", countryCode: "MC" },
    { value: "976", label: "+976 (Mongolia)", countryCode: "MN" },
    { value: "382", label: "+382 (Montenegro)", countryCode: "ME" },
    { value: "212", label: "+212 (Morocco)", countryCode: "MA" },
    { value: "258", label: "+258 (Mozambique)", countryCode: "MZ" },
    { value: "95", label: "+95 (Myanmar)", countryCode: "MM" },
    { value: "264", label: "+264 (Namibia)", countryCode: "NA" },
    { value: "674", label: "+674 (Nauru)", countryCode: "NR" },
    { value: "977", label: "+977 (Nepal)", countryCode: "NP" },
    { value: "31", label: "+31 (Netherlands)", countryCode: "NL" },
    { value: "64", label: "+64 (New Zealand)", countryCode: "NZ" },
    { value: "505", label: "+505 (Nicaragua)", countryCode: "NI" },
    { value: "227", label: "+227 (Niger)", countryCode: "NE" },
    { value: "234", label: "+234 (Nigeria)", countryCode: "NG" },
    { value: "47", label: "+47 (Norway)", countryCode: "NO" },
    { value: "968", label: "+968 (Oman)", countryCode: "OM" },
    { value: "92", label: "+92 (Pakistan)", countryCode: "PK" },
    { value: "680", label: "+680 (Palau)", countryCode: "PW" },
    { value: "970", label: "+970 (Palestine)", countryCode: "PS" },
    { value: "507", label: "+507 (Panama)", countryCode: "PA" },
    { value: "675", label: "+675 (Papua New Guinea)", countryCode: "PG" },
    { value: "595", label: "+595 (Paraguay)", countryCode: "PY" },
    { value: "51", label: "+51 (Peru)", countryCode: "PE" },
    { value: "63", label: "+63 (Philippines)", countryCode: "PH" },
    { value: "48", label: "+48 (Poland)", countryCode: "PL" },
    { value: "351", label: "+351 (Portugal)", countryCode: "PT" },
    { value: "974", label: "+974 (Qatar)", countryCode: "QA" },
    { value: "40", label: "+40 (Romania)", countryCode: "RO" },
    { value: "7", label: "+7 (Russia)", countryCode: "RU" },
    { value: "250", label: "+250 (Rwanda)", countryCode: "RW" },
    { value: "685", label: "+685 (Samoa)", countryCode: "WS" },
    { value: "378", label: "+378 (San Marino)", countryCode: "SM" },
    { value: "239", label: "+239 (Sao Tome and Principe)", countryCode: "ST" },
    { value: "966", label: "+966 (Saudi Arabia)", countryCode: "SA" },
    { value: "221", label: "+221 (Senegal)", countryCode: "SN" },
    { value: "381", label: "+381 (Serbia)", countryCode: "RS" },
    { value: "248", label: "+248 (Seychelles)", countryCode: "SC" },
    { value: "232", label: "+232 (Sierra Leone)", countryCode: "SL" },
    { value: "65", label: "+65 (Singapore)", countryCode: "SG" },
    { value: "421", label: "+421 (Slovakia)", countryCode: "SK" },
    { value: "386", label: "+386 (Slovenia)", countryCode: "SI" },
    { value: "677", label: "+677 (Solomon Islands)", countryCode: "SB" },
    { value: "252", label: "+252 (Somalia)", countryCode: "SO" },
    { value: "27", label: "+27 (South Africa)", countryCode: "ZA" },
    { value: "34", label: "+34 (Spain)", countryCode: "ES" },
    { value: "94", label: "+94 (Sri Lanka)", countryCode: "LK" },
    { value: "249", label: "+249 (Sudan)", countryCode: "SD" },
    { value: "597", label: "+597 (Suriname)", countryCode: "SR" },
    { value: "46", label: "+46 (Sweden)", countryCode: "SE" },
    { value: "41", label: "+41 (Switzerland)", countryCode: "CH" },
    { value: "963", label: "+963 (Syria)", countryCode: "SY" },
    { value: "886", label: "+886 (Taiwan)", countryCode: "TW" },
    { value: "992", label: "+992 (Tajikistan)", countryCode: "TJ" },
    { value: "255", label: "+255 (Tanzania)", countryCode: "TZ" },
    { value: "66", label: "+66 (Thailand)", countryCode: "TH" },
    { value: "228", label: "+228 (Togo)", countryCode: "TG" },
    { value: "676", label: "+676 (Tonga)", countryCode: "TO" },
    { value: "1-868", label: "+1-868 (Trinidad and Tobago)", countryCode: "TT" },
    { value: "216", label: "+216 (Tunisia)", countryCode: "TN" },
    { value: "90", label: "+90 (Turkey)", countryCode: "TR" },
    { value: "993", label: "+993 (Turkmenistan)", countryCode: "TM" },
    { value: "688", label: "+688 (Tuvalu)", countryCode: "TV" },
    { value: "256", label: "+256 (Uganda)", countryCode: "UG" },
    { value: "380", label: "+380 (Ukraine)", countryCode: "UA" },
    { value: "971", label: "+971 (UAE)", countryCode: "AE" },
    { value: "44", label: "+44 (UK)", countryCode: "GB" },
    { value: "1", label: "+1 (USA)", countryCode: "US" },
    { value: "598", label: "+598 (Uruguay)", countryCode: "UY" },
    { value: "998", label: "+998 (Uzbekistan)", countryCode: "UZ" },
    { value: "678", label: "+678 (Vanuatu)", countryCode: "VU" },
    { value: "58", label: "+58 (Venezuela)", countryCode: "VE" },
    { value: "84", label: "+84 (Vietnam)", countryCode: "VN" },
    { value: "681", label: "+681 (Wallis and Futuna)", countryCode: "WF" },
    { value: "967", label: "+967 (Yemen)", countryCode: "YE" },
    { value: "260", label: "+260 (Zambia)", countryCode: "ZM" },
    { value: "263", label: "+263 (Zimbabwe)", countryCode: "ZW" },
];
